export default __webpack_public_path__ + "static/media/title_ko_pc@2x.edbe3bea.png";